/*
 * Amallow - "Mix 3 Scents" pill
 * ---------------------------------------------------------------
 * Adds a 4th pill after the "3 (Save 15%)" variant pill. It is not
 * a variant - it is a link to the Build Your Own Tallow Trio page.
 *
 * Two things worth knowing before editing this file:
 *
 * 1. STYLING. Dawn styles these pills with `input[type=radio] + label`,
 *    which an <a> can never match, so the look is copied at runtime
 *    off a real pill. It copies from an UNSELECTED pill on purpose -
 *    copying from the "3" pill made the link render black whenever 3
 *    was the chosen quantity, as though it were selected too.
 *
 * 2. REDRAWS. Dawn replaces the whole variant picker when you pick a
 *    scent, which destroys the link. It gets put back synchronously
 *    inside the MutationObserver (before the browser paints) and, for
 *    swaps that land across several frames, by a short frame watcher
 *    kicked off on every change event. Deferring either of those is
 *    what makes the pill visibly blink. A small flicker remains and
 *    cannot be removed here - the only real fix is rendering the link
 *    server-side in snippets/product-variant-picker.liquid so it is
 *    part of the HTML Dawn fetches on every variant change.
 *
 * Loaded from layout/theme.liquid. Runs ONLY on the product pages
 * listed in allowedHandles below.
 *
 * Console helpers: window.amallowMixMatch.inject() / .config
 */
(function () {
  'use strict';

  var CONFIG = {
    // ---------------------------------------------------------------
    // WHICH PRODUCTS SHOW THE PILL
    // Product handles only (the bit after /products/ in the URL), NOT
    // titles. Add a new cream here when you launch one. Leave the list
    // empty to show the pill on every product page that has the pills.
    // ---------------------------------------------------------------
    allowedHandles: [
      'whipped-tallow-cream-unscented',
      'whipped-tallow-cream-unscented-jojoba-oil',
      'whipped-tallow-cream-scented',            // Clean Cloud
      'whipped-tallow-cream-vanilla-lavender',
      'whipped-tallow-cream-vanilla-latte',
      'whipped-tallow-cream-orange-creamsicle',
      'whipped-tallow-cream-blue-tansy'
    ],

    // The mix & match product page.
    linkUrl: '/products/build-your-own-tallow-trio',

    // What the new pill says. Kept parallel with the other pills
    // ("Save 15%", not "15% Off") so the row reads as one set.
    linkLabel: 'Mix 3 Scents (Save 15%)',

    // Text of the LAST existing pill - we insert right after it.
    lastPillText: '3 (Save 15%)',

    openInNewTab: false,

    // How long to keep re-checking after a variant change, in ms.
    watchMs: 2000,

    // Logs what it is doing to the browser console.
    debug: false
  };

  var FLAG = 'data-amallow-mixmatch';

  function log() {
    if (CONFIG.debug && window.console) {
      console.log.apply(console, ['[mix-match]'].concat([].slice.call(arguments)));
    }
  }

  function present() {
    return !!document.querySelector('[' + FLAG + ']');
  }

  // Current product handle, e.g. /en-ca/products/foo?variant=1 -> 'foo'
  function currentHandle() {
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]).toLowerCase() : null;
  }

  function isAllowedPage() {
    var handle = currentHandle();
    if (!handle) return false;
    if (!CONFIG.allowedHandles.length) return true;
    for (var i = 0; i < CONFIG.allowedHandles.length; i++) {
      if (CONFIG.allowedHandles[i].toLowerCase() === handle) return true;
    }
    return false;
  }

  function norm(str) {
    return (str || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  // Text belonging directly to this element, ignoring child elements.
  function ownText(el) {
    var out = '';
    for (var i = 0; i < el.childNodes.length; i++) {
      if (el.childNodes[i].nodeType === 3) out += el.childNodes[i].nodeValue;
    }
    return norm(out);
  }

  function labelFor(input) {
    if (input.id) {
      try {
        var byFor = document.querySelector('label[for="' + input.id + '"]');
        if (byFor) return byFor;
      } catch (e) { /* odd id, fall through */ }
    }
    var sib = input.nextElementSibling;
    while (sib && sib.tagName !== 'LABEL') sib = sib.nextElementSibling;
    return sib || null;
  }

  // The radio input carrying this value -> its <label>.
  function findPillByInput(text) {
    var target = norm(text);
    var inputs = document.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < inputs.length; i++) {
      if (norm(inputs[i].value) !== target) continue;
      var label = labelFor(inputs[i]);
      if (label) {
        log('matched via radio input');
        return label;
      }
    }
    return null;
  }

  // Text-based fallbacks. Document order means the last match is the
  // deepest one.
  function findPillByText(text) {
    var target = norm(text);
    var nodes = document.querySelectorAll('label, button, a, li, span, div, p');
    var own = null;
    var full = null;
    for (var i = 0; i < nodes.length; i++) {
      if (ownText(nodes[i]) === target) own = nodes[i];
      if (norm(nodes[i].textContent) === target) full = nodes[i];
    }
    if (own) log('matched via own text');
    else if (full) log('matched via full text');
    return own || full;
  }

  // An UNSELECTED, enabled pill in the same row, to copy the look from.
  // Falls back to the pill itself if there is nothing better around.
  function styleSource(pill) {
    var row = pill.parentElement;
    if (!row) return pill;

    var inputs = row.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].checked || inputs[i].disabled) continue;
      var label = labelFor(inputs[i]);
      if (label && label !== pill) {
        log('copying style from unselected pill:', norm(inputs[i].value));
        return label;
      }
    }

    log('no unselected pill to copy from, using the target pill');
    return pill;
  }

  var STYLE_PROPS = [
    'display', 'align-items', 'justify-content', 'box-sizing',
    'margin-top', 'margin-right', 'margin-bottom', 'margin-left',
    'padding-top', 'padding-right', 'padding-bottom', 'padding-left',
    'border-top', 'border-right', 'border-bottom', 'border-left',
    'border-radius', 'background-color', 'color', 'opacity',
    'font-family', 'font-size', 'font-weight', 'font-style',
    'line-height', 'letter-spacing', 'text-align', 'text-transform',
    'height', 'min-height', 'white-space', 'box-shadow'
  ];

  function copyStyles(from, to, props) {
    var cs = window.getComputedStyle(from);
    for (var i = 0; i < props.length; i++) {
      var val = cs.getPropertyValue(props[i]);
      if (val) to.style.setProperty(props[i], val);
    }
  }

  function buildPill(pill) {
    var a = document.createElement('a');
    var source = styleSource(pill);

    a.href = CONFIG.linkUrl;
    a.textContent = CONFIG.linkLabel;
    a.setAttribute(FLAG, '1');
    if (CONFIG.openInNewTab) {
      a.target = '_blank';
      a.rel = 'noopener';
    }

    if (typeof source.className === 'string' && source.className) {
      a.className = source.className;
    }
    a.className = (a.className ? a.className + ' ' : '') + 'amallow-mixmatch-pill';

    copyStyles(source, a, STYLE_PROPS);

    a.style.setProperty('width', 'auto');
    a.style.setProperty('flex', '0 0 auto');
    a.style.setProperty('text-decoration', 'none');
    a.style.setProperty('cursor', 'pointer');
    a.style.setProperty('display', 'inline-flex');
    a.style.setProperty('align-items', 'center');
    a.style.setProperty('justify-content', 'center');

    return a;
  }

  function addHoverStyle() {
    if (document.getElementById('amallow-mixmatch-style')) return;
    var s = document.createElement('style');
    s.id = 'amallow-mixmatch-style';
    s.textContent =
      '.amallow-mixmatch-pill{transition:opacity .15s ease;}' +
      '.amallow-mixmatch-pill:hover{opacity:.7;}' +
      '.amallow-mixmatch-pill:focus-visible{outline:2px solid currentColor;outline-offset:2px;}';
    document.head.appendChild(s);
  }

  function inject() {
    if (present()) return true;

    var pill = findPillByInput(CONFIG.lastPillText) || findPillByText(CONFIG.lastPillText);

    if (!pill) {
      log('no pill found for', CONFIG.lastPillText);
      return false;
    }
    if (!pill.parentElement) {
      log('pill has no parent');
      return false;
    }

    addHoverStyle();
    pill.parentElement.insertBefore(buildPill(pill), pill.nextSibling);
    log('inserted after', pill);
    return true;
  }

  // Re-check once per frame for a short while, so a picker that gets
  // swapped in over several frames still gets the pill back on the
  // very first frame it exists.
  var watching = false;
  var watchUntil = 0;

  function startWatch(ms) {
    watchUntil = Math.max(watchUntil, Date.now() + (ms || CONFIG.watchMs));
    if (watching || !window.requestAnimationFrame) return;

    watching = true;
    (function tick() {
      if (!present()) inject();
      if (Date.now() < watchUntil) {
        window.requestAnimationFrame(tick);
      } else {
        watching = false;
      }
    })();
  }

  function start() {
    if (!isAllowedPage()) {
      log('skipping - not an allowed product page:', currentHandle());
      return;
    }

    log('running on', currentHandle());
    inject();

    // In case the pills render late on first load.
    [300, 800, 1500, 3000, 5000].forEach(function (ms) {
      setTimeout(inject, ms);
    });

    // Picking a scent or a quantity kicks off a redraw.
    document.addEventListener('change', function () { startWatch(); }, true);

    if (!window.MutationObserver) return;

    new MutationObserver(function () {
      if (present()) return;

      // Synchronous on purpose: runs before the next paint, so the pill
      // is back in the DOM before anything is drawn.
      inject();
      if (!present()) startWatch(600);
    }).observe(document.body, { childList: true, subtree: true });
  }

  // Handy for poking at it from the console.
  window.amallowMixMatch = { inject: inject, config: CONFIG, handle: currentHandle };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
